import { XyoWorldApiWrapper } from '@xyo-network/sdk-xyoworld-js'
import { PropsWithChildren, useContext, useEffect, useRef, useState } from 'react'

import { AuthenticationContext } from '../Authentication'
import { ApiDomain } from './ApiDomain'
import Context from './Context'

interface Props {
  uri?: string
}

const Provider: React.FC<PropsWithChildren<Props>> = (props) => {
  const { authEntity, auth } = useContext(AuthenticationContext)

  const apiDomain = useRef(
    new ApiDomain({
      beta: 'https://dev-api.world.xyo.network',
      local: 'http://localhost:3030/dev',
      prod: 'https://api.world.xyo.network',
    }),
  )

  const [apiWrapper, setApiWrapper] = useState<XyoWorldApiWrapper>()

  useEffect(() => {
    const token = auth?.token
    console.log(`ApiContext.SettingApiWrapper: ${token}`)
    const userid = authEntity?.address.toLowerCaseString()
    if (apiDomain) {
      const api = XyoWorldApiWrapper.get({ apiDomain: apiDomain.current.url, jwtToken: token, userid })
      setApiWrapper(api)
    }
  }, [apiDomain, auth, authEntity])

  return (
    <Context.Provider
      value={{
        apiDomain: apiDomain.current,
        apiWrapper,
      }}
      {...props}
    />
  )
}

export default Provider
